import _typeof from '@babel/runtime/helpers/typeof';
import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../../constants/colors.js';
import { styles } from '../../constants/styles.js';
import { buttonThemeWeb, buttonThemeNative, buttonDarkThemeWeb, buttonDarkThemNative } from '../../Button/theme.js';
import { inputFieldThemeWeb, inputFieldThemeNative, inputFieldDarkThemeNative } from '../../InputField/theme.js';
import { descriptionListThemeWeb, descriptionListDarkThemeWeb } from '../../DescriptionList/theme.js';
import { checkboxThemeNative, checkboxThemeWeb, checkboxDarkThemeWeb, checkboxDarkThemeNative } from '../../Checkbox/theme.js';
import { radioThemeNative, radioThemeWeb, radioDarkThemeNative, radioDarkThemeWeb } from '../../Radio/theme.js';
import { accordionThemeNative, accordionThemeWeb, accordionDarkThemeWeb, accordionDarkThemeNative } from '../../Accordion/theme.js';
import { selectThemeNative, selectThemeWeb, selectDarkThemeWeb, selectDarkThemeNative } from '../../Select/theme.js';
import { chipsThemeNative, chipsThemeWeb, chipsDarkThemeWeb, chipsDarkThemeNative } from '../../Chips/theme.js';
import { contentSwitcherThemeNative, contentSwitcherThemeWeb, contentSwitcherDarkThemeWeb } from '../../ContentSwitcher/theme.js';
import { dotsThemeNative, dotsThemeWeb, dotsDarkThemeWeb, dotsDarkThemeNative } from '../../Dots/theme.js';
import { errorMessageThemeNative, errorMessageThemeWeb } from '../../ErrorMessage/theme.js';
import { linkThemeWeb, linkThemeNative } from '../../Link/theme.js';
import { paginationThemeWeb, paginationThemeNative } from '../../Pagination/theme.js';
import { popoverThemeWeb } from '../../Popover/theme.js';
import { tableThemeWeb, tableDarkThemeWeb } from '../../Table/theme.js';
import { tabsThemeWeb, tabsThemeNative, tabsDarkThemeWeb } from '../../Tabs/theme.js';
import { toggleThemeWeb, toggleThemeNative, toggleDarkThemeNative, toggleDarkThemeWeb } from '../../Toggle/theme.js';
import { stepperThemeWeb } from '../../Stepper/theme.js';
import 'styled-components';
import { sliderThemeNative, sliderThemeWeb, sliderDarkThemeNative } from '../../Slider/theme.js';
import { contextLinkThemeNative, contextLinkDarkThemeNative } from '../../ContextLink/theme.js';
import { headingThemeNative, headingThemeWeb } from '../../Heading/theme.js';
import { listItemsThemeWeb, listItemsDarkThemeWeb } from '../components/ListItems/theme.js';
import { linearProgressThemeWeb, linearProgressDarkThemeWeb } from '../../LinearProgress/theme.js';
import { circularProgressThemeWeb } from '../../CircularProgress/theme.js';
import { multiselectThemeWeb } from '../../Multiselect/theme.js';
import { npsThemeWeb } from '../../NPS/theme.js';
import { contentTextThemeWeb, contentTextThemeNative } from '../../ContentText/theme.js';
import { datepickerThemeWeb, datepickerDarkThemeWeb } from '../../DatePicker/theme.js';
import { placeholderThemeWeb, placeholderDarkThemeWeb } from '../../Placeholder/theme.js';
import { sectionThemeWeb, sectionDarkThemeWeb } from '../../Section/theme.js';
var defaultTheme = {
  colors: {
    primary: colors.forestGreen,
    secondary: colors.cushyBlue,
    accent: colors.punchRed,
    alert: colors.hazeRedOrange,
    text: colors.inkGrey,
    background: colors.snowWhite
  },
  borders: {
    radius: undefined
  },
  font: {
    family: styles.fontFamily.base,
    fontMapNative: {
      regular: 'FortumSansTT-Regular',
      regularItalic: 'FortumSansTT-RegularItalic',
      light: 'FortumSansTT-Light',
      lightItalic: 'FortumSansTT-LightItalic',
      bold: 'FortumSansTT-Bold',
      boldItalic: 'FortumSansTT-BoldItalic',
      medium: 'FortumSansTT-Medium',
      mediumItalic: 'FortumSansTT-MediumItalic'
    }
  },
  accordion: {
    "native": accordionThemeNative,
    web: accordionThemeWeb
  },
  button: {
    web: buttonThemeWeb,
    "native": buttonThemeNative
  },
  chips: {
    "native": chipsThemeNative,
    web: chipsThemeWeb
  },
  circularProgress: {
    web: circularProgressThemeWeb,
    "native": null
  },
  checkbox: {
    "native": checkboxThemeNative,
    web: checkboxThemeWeb
  },
  contentSwitcher: {
    "native": contentSwitcherThemeNative,
    web: contentSwitcherThemeWeb
  },
  contentText: {
    web: contentTextThemeWeb,
    "native": contentTextThemeNative
  },
  contextLink: {
    web: null,
    "native": contextLinkThemeNative
  },
  datepicker: {
    "native": null,
    web: datepickerThemeWeb
  },
  descriptionList: {
    "native": null,
    web: descriptionListThemeWeb
  },
  dots: {
    "native": dotsThemeNative,
    web: dotsThemeWeb
  },
  errorMessage: {
    "native": errorMessageThemeNative,
    web: errorMessageThemeWeb
  },
  heading: {
    "native": headingThemeNative,
    web: headingThemeWeb
  },
  inputField: {
    web: inputFieldThemeWeb,
    "native": inputFieldThemeNative
  },
  linearProgress: {
    web: linearProgressThemeWeb,
    "native": null
  },
  link: {
    web: linkThemeWeb,
    "native": linkThemeNative
  },
  listItems: {
    web: listItemsThemeWeb,
    "native": null
  },
  multiselect: {
    "native": null,
    web: multiselectThemeWeb
  },
  nps: {
    "native": null,
    web: npsThemeWeb
  },
  pagination: {
    web: paginationThemeWeb,
    "native": paginationThemeNative
  },
  placeholder: {
    "native": null,
    web: placeholderThemeWeb
  },
  popover: {
    web: popoverThemeWeb,
    "native": null
  },
  radio: {
    "native": radioThemeNative,
    web: radioThemeWeb
  },
  section: {
    "native": null,
    web: sectionThemeWeb
  },
  select: {
    "native": selectThemeNative,
    web: selectThemeWeb
  },
  slider: {
    "native": sliderThemeNative,
    web: sliderThemeWeb
  },
  stepper: {
    "native": null,
    web: stepperThemeWeb
  },
  table: {
    "native": null,
    web: tableThemeWeb
  },
  tabs: {
    web: tabsThemeWeb,
    "native": tabsThemeNative
  },
  toggle: {
    web: toggleThemeWeb,
    "native": toggleThemeNative
  }
};

var darkTheme = _extends({}, defaultTheme, {
  colors: {
    primary: colors.optimisticGreen,
    secondary: colors.waterBlue,
    accent: colors.powerRed,
    alert: colors.energeticRedOrange,
    text: colors.cloudGrey,
    background: colors.raisinGrey
  },
  accordion: {
    web: accordionDarkThemeWeb,
    "native": accordionDarkThemeNative
  },
  button: {
    web: buttonDarkThemeWeb,
    "native": buttonDarkThemNative
  },
  checkbox: {
    web: checkboxDarkThemeWeb,
    "native": checkboxDarkThemeNative
  },
  chips: {
    web: chipsDarkThemeWeb,
    "native": chipsDarkThemeNative
  },
  contentSwitcher: {
    web: contentSwitcherDarkThemeWeb,
    "native": contentSwitcherThemeNative
  },
  contextLink: {
    web: null,
    "native": contextLinkDarkThemeNative
  },
  datepicker: {
    "native": null,
    web: datepickerDarkThemeWeb
  },
  descriptionList: {
    web: descriptionListDarkThemeWeb,
    "native": null
  },
  dots: {
    web: dotsDarkThemeWeb,
    "native": dotsDarkThemeNative
  },
  inputField: {
    web: inputFieldThemeWeb,
    "native": inputFieldDarkThemeNative
  },
  linearProgress: {
    web: linearProgressDarkThemeWeb,
    "native": null
  },
  listItems: {
    web: listItemsDarkThemeWeb,
    "native": null
  },
  placeholder: {
    web: placeholderDarkThemeWeb,
    "native": null
  },
  radio: {
    "native": radioDarkThemeNative,
    web: radioDarkThemeWeb
  },
  section: {
    web: sectionDarkThemeWeb,
    "native": null
  },
  select: {
    web: selectDarkThemeWeb,
    "native": selectDarkThemeNative
  },
  toggle: {
    "native": toggleDarkThemeNative,
    web: toggleDarkThemeWeb
  },
  slider: {
    "native": sliderDarkThemeNative,
    web: sliderThemeWeb
  },
  table: {
    web: tableDarkThemeWeb,
    "native": null
  },
  tabs: {
    "native": tabsThemeNative,
    web: tabsDarkThemeWeb
  }
}); // this adds the theme type to all styled() components
// https://styled-components.com/docs/api#create-a-declarations-file
// can be any style string, but also a keyword mapping to a theme value


var resolveThemeKeyword = function resolveThemeKeyword(style, theme) {
  if (style === 'primary') {
    return theme.colors.primary;
  } else if (style === 'secondary') {
    return theme.colors.secondary;
  } else if (style === 'alert') {
    return theme.colors.alert;
  } else if (style === 'text') {
    return theme.colors.text;
  } else if (style === 'background') {
    return theme.colors.background;
  } else if (style === 'borders.radius') {
    return theme.borders.radius || '0px';
  }

  return style;
};

function isValidThemeSection(value) {
  return value in defaultTheme;
}

var themeResolver = function themeResolver(inputTheme) {
  // deep clone
  var theme = JSON.parse(JSON.stringify(inputTheme));
  Object.keys(defaultTheme).forEach(function (key) {
    // istanbul ignore next
    if (!isValidThemeSection(key)) {
      throw new Error("Invalid property provided for Theming configuration: property with key \"".concat(key, "\" does not exist"));
    }

    if (!theme[key]) {
      throw new Error("Invalid theme provided for elemental-ui - key: ".concat(key, " is defined by the defaultTheme but not provided by the given theme"));
    }
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var recurse = function recurse(obj) {
    for (var key in obj) {
      var value = obj[key];

      if (value != undefined) {
        if (value && _typeof(value) === 'object') {
          recurse(value);
        } else {
          obj[key] = resolveThemeKeyword(value, theme);
        }
      }
    }
  };

  recurse(theme);
  return theme;
};

export { darkTheme, defaultTheme, resolveThemeKeyword, themeResolver };